import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=49036535&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=49036535&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49036535",
  null
  
)

export default component.exports